module.exports = __webpack_public_path__ + "static/media/logo-francorosso@2x.a72c622b.png";